<div #clickable class="position-absolute" [ngStyle]="{
  'top.px': box.top,
  'width.px': box.width,
  'height.px': box.height,
  'left.px': box.left,
  'background-image':  'url(\'' + backgroundImage + '\')',
  'background-repeat': 'no-repeat',
  }">
  <ng-content></ng-content>  
</div>